import React from 'react';
import { Helmet } from 'react-helmet';

export const SignUpHelmet = () => {
	return (
		<Helmet>
			<title>Sign up | Stash</title>
			<link rel="canonical" href={`${window.location.origin}/sign-up`} />
			<meta
				name="description"
				content="Sign up for Stash so you can start building wealth and improving your financial life."
			/>
			<meta property="og:title" content="Sign up | Stash" />
			<meta
				property="og:description"
				content="Sign up for Stash so you can start building wealth and improving your financial life."
			/>
			<meta property="og:type" content="website" />
			<meta property="og:url" content="https://app.stash.com/sign-up" />
			<meta
				property="og:image"
				content="https://www.stash.com/assets/images/metadata/HomePage_MetaImg.jpg"
			/>
			<meta name="twitter:title" content="Sign up | Stash" />
			<meta
				name="twitter:description"
				content="Sign up for Stash so you can start building wealth and improving your financial life."
			/>
			<meta name="twitter:site" content="@stash" />
			<meta
				name="twitter:url"
				content="https://app.stash.com/sign-up/get-started"
			/>
			<meta name="twitter:card" content="summary_large_image" />
			<meta
				name="twitter:image"
				content="https://www.stash.com/assets/images/metadata/HomePage_MetaImg.jpg"
			/>
		</Helmet>
	);
};

export default SignUpHelmet;
